import React from "react";

const Footer = () => {

    return (
        <>
            <h3 className="footer-text">© Linnea Frisk 2022</h3>
        </>
    )
}

export default Footer